module.exports = __webpack_public_path__ + "static/img/scientific_img_two.a01184d1.png";